const API_ENDPOINTS = {
  CREATE_TICKET: "/support/ticket/create/guest",
  CREATE_HUBBLE_FORM: "/hubble/create",
  GET_MY_UPLOADS: "/hubble/getmy?page=1&limit=999",
  GET_MY_UPLOAD: (id) => `/hubble/getbyid/${id}`,
  UPDATE_HUBBLE_FORM: (id) => `hubble/update/user/${id}`,
  REMOVE_UPLOAD: (id) => `/hubble/remove/${id}`,
  GET_MY_PRICE: `/pelebaroon/myprice`,
  PURCHASE: `/pelebaroon/purchase`,
  GET_HUBBLE_REFEREE: (refereed, searchStr) =>
    `/hubbleReferee/getall/referee?refereed=${refereed}&searchString=${searchStr}`,
  IS_REFEREE: `/hubbleRefereeUser/isreferee`,
  REFEREE_FORM: `/hubbleReferee/create`,
  GET_REFEREE_BY_FORM_iD: (id) => `/hubbleReferee/getRefereeUsingFormId/${id}`,
  UPDATE_REFEREE_BY_ID: (id) => `/hubbleReferee/update/${id}`,
  CREATE_WORD_GAME_TICKET: "/wordgame/ticket/create",
  CREATE_WORD_GAME_TICKET_v2: "/wordgame/ticket/create/v2",
  GET_WORD_GAME_TICKET_BY_ID: (id) => `/wordgame/ticket/getbyid/${id}`,
  SUBMIT_WORD_GAME: (id) => `/wordgame/ticket/submit/${id}`,
  GET_WORD_GAME_COUNT: "/wordgame/ticket/todayCount",
  GET_WORD_GAME_EVENT_BY_ID: (id) => `/wordgame/event/getsingle/${id}`,
};

export default API_ENDPOINTS;
